import { Box, Typography } from '@mui/material';
import PublicPage from '../components/PublicPage.tsx';
import { PHONE_LABEL } from '../demo/demoLinks.ts';
import SetPasswordForm from './SetPasswordForm.tsx';
import useLinkSecret from './useLinkSecret.ts';

/** The welcome email's link: set a password, then land signed in. */
const SetPasswordPage = () => {
  const token = useLinkSecret('token');

  return (
    <PublicPage>
      <Box sx={{ mt: 3 }}>
        <Typography sx={{ fontWeight: 700 }}>Set your password</Typography>
        <Typography variant="body2" sx={{ mt: 0.75, color: 'text.secondary' }}>
          {token
            ? 'Choose a password for your Forge account.'
            : `This link is incomplete. Open it again from your welcome email, or call Nick at ${PHONE_LABEL}.`}
        </Typography>
      </Box>
      {token && <SetPasswordForm token={token} />}
    </PublicPage>
  );
};

export default SetPasswordPage;
